import { Image } from '@cian/ui-kit/image';
import { UIHeading4, Body2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';

export interface INewbuildingEntryResaleItemProps {
  onClick(): void;
  imageUrl: string;
  title: string;
  price: string;
  description: string[];
  address: string;
  locationIcon: React.ReactNode | null;
  locationIconColor: string | null;
  locationText: string | null;
  timeIcon: React.ReactNode | null;
  timeText: string | null;
  url: string;
}

export function NewbuildingEntryResaleItem({
  onClick,
  imageUrl,
  title,
  price,
  description,
  address,
  locationIcon,
  locationIconColor,
  locationText,
  timeIcon,
  timeText,
  url,
}: INewbuildingEntryResaleItemProps) {
  return (
    <a className={styles['container']} onClick={onClick} href={url}>
      <div className={styles['image']}>
        <Image src={imageUrl} alt={title} height={'140px'} width={'100%'} objectFit={'contain'} borderRadius={0} />
      </div>
      <div className={styles['content']}>
        <div className={styles['title']}>
          <Body2 whiteSpace={'nowrap'} as={'span'}>
            {title}
          </Body2>
        </div>
        <div className={styles['price']}>
          <UIHeading4 whiteSpace={'nowrap'} as={'span'}>
            {price}
          </UIHeading4>
        </div>
        <div className={styles['description']}>
          {description.map((item, idx) => (
            <React.Fragment key={`description-${idx}`}>
              <Body2 as={'span'} whiteSpace={'nowrap'}>
                {item}
              </Body2>{' '}
            </React.Fragment>
          ))}
        </div>
        <div className={styles['address']}>
          <Body2 whiteSpace={'nowrap'} as={'span'} color={'text-secondary-default'}>
            {address}
          </Body2>
        </div>
        {locationIconColor && (
          <div className={styles['locationBlock']}>
            <div className={styles['location']}>
              <span className={styles['locationIcon']} style={{ color: locationIconColor }}>
                {locationIcon}
              </span>
              <span className={styles['locationText']}>
                <Body2 whiteSpace={'nowrap'} as={'span'}>
                  {locationText}
                </Body2>
              </span>
            </div>
            <div className={styles['time']}>
              {timeIcon && <span className={styles['timeIcon']}>{timeIcon}</span>}
              <span className={styles['timeText']}>
                <Body2 whiteSpace={'nowrap'} as={'span'} color={'text-secondary-default'}>
                  {timeText}
                </Body2>
              </span>
            </div>
          </div>
        )}
      </div>
    </a>
  );
}
